// src/components/ui/ProtectedRoute.tsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';

/**
 * Guard de rutas: redirige a /login si no hay token válido en el store.
 * El token se persiste en localStorage ('fg_admin_token') y se
 * rehidrata en el estado inicial de authSlice.
 */
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = useAppSelector((s) => s.auth.token);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
